import styled, { createGlobalStyle } from 'styled-components';
import 'swiper/css';
import 'swiper/css/effect-cards';

export const Wrapper = styled.div`
  display: flex;
  max-width: 840px;
  width: 100%;
  align-self: center;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  height: 100%;
  padding: 30px 0;

  .flashcard-swiper {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const TourStepOverlayOnlyStyle = createGlobalStyle`
  .ant-tour {
    width: 100vw !important;
    height: 100vh !important;
  }
  .ant-tour-close {
    color: ${({ theme }) => theme.colors.white} !important;
    font-size: 24px !important;
    cursor: pointer !important;
    z-index: 9999999 !important;
  }
  .ant-tour-cover {
    width: 100vw !important;
    height: 100vh !important;
  }
  .ant-tour-footer {
    display: none !important;
  }
  .ant-tour .ant-tour-inner {
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    background-color: transparent !important;
  }
`;
